import { Component } from "react";

import "./style.scss";

let id = 0;

class EditImage extends Component {

    constructor(props){
        super(props);
        this.id = id++;
    }

    state = {
        rangeValue: 100,
        image: null,
        zoom: 1
    }

    rangeHandler = (e) => {
        this.setState({ rangeValue: e.target.value });
        this.props.onZoomChange(e.target.value/100);
    }

    fileHandler = (e)=>{
        if(this.props.onChange) this.props.onChange(e);
        let target = e.target;
        let files = target.files;
        if(files[0]){
            var reader = new FileReader();
            reader.onload = (e)=> {
                this.setState({image:e.target.result});
                this.props.onImageSelect(e.target.result);
            }
            reader.readAsDataURL(files[0]);
        }
    }

    componentDidUpdate(){
        if(this.props.show) this.input.click();
    }

    render() {
        let elId = `upload-${this.id}`;
        return (
            <>
                <div className={`edit-image ${this.state.image ? "editing" : ""}`}>
                    <label htmlFor={elId}>
                        {this.props.text}
                        <div className="plus"></div>
                        <input ref={el => (this.input = el)} id={elId} type="file" name="file" accept="image/*" onChange={this.fileHandler} />
                    </label>
                    <div className="editor">
                        <div className="container row">
                            <div className="selected-image"><img src={this.state.image} alt="Customization" /></div>
                            <div className="range-slider">
                                <span>{`Image Size: ${this.state.rangeValue}%`}</span>
                                <input className="range" type="range" min="50" max="200" value={this.state.rangeValue} onChange={this.rangeHandler} />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default EditImage;